import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import Select, { components } from "react-select";
import ReactTooltip from "react-tooltip";
import { FiInfo } from "react-icons/fi";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
// import { getData } from "country-list";
import Axios from "../../axios/Axios";


const AddAgentPlan = () => {
  const { id } = useParams();
  const history = useHistory();
  // const countryList = getData();
  // const countryOptions = [
  //   { value: "ALL", label: "All" },
  //   ...countryList.map((country) => ({
  //     value: country.name,
  //     label: country.name,
  //   })),
  // ];
  const lStorage = userloginDetails();

  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  const [formData, setFormData] = useState({
    planName: "",
    currency: "INR",
    country: [],
    agentPrice: "",
    agentQtyMin: "",
    agentQtyMax: "",
    agentDiscount: "",
  });
  const [countryOptions, setCountryOptions] = useState([{ value: "ALL", label: "All" }]);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bgColor, setBgColor] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCountryChange = (selectedOptions) => {
    if (!selectedOptions) {
      setFormData({ ...formData, country: [] });
      return;
    }

    const allCountries = countryOptions.filter(c => c.value !== "ALL");
    const isAllClicked = selectedOptions.some(c => c.value === "ALL");

    if (isAllClicked) {
      const allCurrentlySelected = formData.country.length === allCountries.length;
      setFormData({
        ...formData,
        country: allCurrentlySelected ? [] : allCountries,
      });
    } else {
      setFormData({ ...formData, country: selectedOptions });
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: id ? "agent&flow_plans_update" : "agent&flow_plans_create",
        plan_name: formData.planName,
        currency: formData.currency,
        country:
          formData.country.length === countryOptions.filter(c => c.value !== "ALL").length
            ? ["ALL"]
            : formData.country.map(c => c.value),
        agent_price: Number(formData.agentPrice),
        agent_quantity: {
          min: Number(formData.agentQtyMin),
          max: Number(formData.agentQtyMax),
        },
        agent_discount: Number(formData.agentDiscount),
      };
      if (id) {
        payload.id = id;
      }
      const response = await Axios.post(`${NODE_HOST_URL}/admin/plans`, payload);
      const result = response.data;

      if (result.success === true) {

        setSuccessMessage(true);
        setBgColor("alert alert-success alert-dismissible");
        setErrorMessage(result.message);
        setTimeout(() => {
          history.push("/admin/agent-plan");
        }, 1000);

      }
      else {
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(result.message);
      }
    }
    catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage(error?.response?.data?.message || "Something went wrong!");
    }

  }

  const normalizeCountry = (apiCountry) => {
    if (!apiCountry) return "";

    return apiCountry
      .toLowerCase()
      .replace("(the)", "")
      .trim()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const fetchPlanDetail = async (id) => {
    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: "agent&flow_plans_retrieve_dtl",
        id: id
      };
      const response = await Axios.post(`${NODE_HOST_URL}/admin/plans`, payload);
      const result = response.data;

      if (result.success === true) {
        const data = result.data;
        setFormData({
          planName: data.plan_name,
          currency: data.currency,
          country: Array.isArray(data.country)
            ? data.country.map(c => ({
              value: normalizeCountry(c),
              label: normalizeCountry(c)
            }))
            : [{
              value: normalizeCountry(data.country),
              label: normalizeCountry(data.country)
            }],
          agentPrice: data.agent_price,
          agentQtyMin: data.agent_quantity.min,
          agentQtyMax: data.agent_quantity.max,
          agentDiscount: data.agent_discount,
        });
      }
      else {
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(result.message);
      }

    }
    catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    fetch(`${HOST_URL}/country_master.php`)
      .then((res) => res.json())
      .then((result) => {
        if (result.success === true) {
          setCountryOptions([
            { value: "ALL", label: "All" },
            ...result.data.map((c) => ({
              label: c.country_name,
              value: c.country_name,
            })),
          ]);
        }
      });
  }, []);

  useEffect(() => {
    if (id) {
      fetchPlanDetail(id);
    }
  }, [id]);


  const InfoLabel = ({ text, info, id, required }) => (
    <label className="form-label d-flex align-items-center gap-3">
      {text}

      {required && <span className="text-danger">*</span>}

      <FiInfo
        size={12}
        className="text-muted"
        data-tip
        data-for={id}
        data-event="click"
        style={{ cursor: "pointer" }}
      />

      <ReactTooltip
        id={id}
        place="right"
        effect="solid"
        globalEventOff="click"
        clickable
      >
        {info}
      </ReactTooltip>
    </label>
  );


  const Option = (props) => {
    const { data, isSelected, selectProps } = props;
    const allCountries = selectProps.options.filter(o => o.value !== "ALL");
    const isAllSelected = selectProps.value?.length === allCountries.length;
    const checked = data.value === "ALL" ? isAllSelected : isSelected;

    return (
      <components.Option {...props}>
        <input type="checkbox" checked={checked} onChange={() => null} style={{ marginRight: 8 }} />
        {data.label}
      </components.Option>
    );
  };

  const MultiValue = (props) => {
    const { index, getValue } = props;
    const selected = getValue();
    const allCountries = countryOptions.filter(c => c.value !== "ALL");
    const isAllSelected = selected.length === allCountries.length && allCountries.length > 0;

    if (isAllSelected) {
      return index === 0 ? (
        <div style={{ margin: "2px 6px", fontSize: 12, color: "#333" }}>All Countries</div>
      ) : null;
    }

    const maxToShow = 3;
    if (index < maxToShow) return <components.MultiValue {...props} />;
    if (index === maxToShow) return (
      <div style={{ marginLeft: 6, fontSize: 12, color: "#666" }}>+{selected.length - maxToShow} more</div>
    );
    return null;
  };

  return (
    <div className="wrapper">
      <AdminLeftMenu />

      <div className="main">
        <AdminHeader />

        <main className="content">
          <div className="container-fluid p-0">

            <div className="row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong>Add New Agent Plan</strong>
                </h3>
              </div>
            </div>
            {successMessage && (
              <div className={bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div>{errorMessage}</div>
              </div>
            )}


            <div className="card p-4">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  {/* Plan Name */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Plan Name"
                      info="Unique name used to identify this agent pricing plan."
                      id="planNameInfo"
                    />

                    <input
                      type="text"
                      name="planName"
                      className="form-control"
                      value={formData.planName}
                      onChange={handleChange}
                      placeholder="Enter Plan Name"
                    />
                  </div>

                  {/* Currency */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Currency"
                      info="Billing currency used for this plan."
                      id="currencyInfo"
                    />

                    <select
                      name="currency"
                      className="form-control"
                      value={formData.currency}
                      onChange={handleChange}
                    >
                      <option value="INR">INR</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </select>
                  </div>

                  {/* Country */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Country"
                      info="Countries where this pricing plan will apply."
                      id="countryInfo"
                    />

                    <Select
                      options={countryOptions}
                      isMulti
                      value={formData.country}
                      onChange={handleCountryChange}
                      placeholder="Select Countries"
                      components={{ Option, MultiValue }}
                      hideSelectedOptions={false}
                      closeMenuOnSelect={false}
                      maxMenuHeight={200}
                      styles={{
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                          color: "black",
                        }),
                      }}
                    />
                  </div>

                  {/* Agent Price */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Agent Price"
                      info="Price charged per agent."
                      id="agentPriceInfo"
                    />

                    <input
                      type="number"
                      name="agentPrice"
                      className="form-control"
                      value={formData.agentPrice}
                      onChange={handleChange}
                      placeholder="Enter Price"
                      min="0"
                    />
                  </div>

                  {/* Agent Quantity Min */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Agent Quantity (Min)"
                      info="Minimum number of agents required."
                      id="agentMinInfo"
                    />

                    <input
                      type="number"
                      name="agentQtyMin"
                      className="form-control"
                      value={formData.agentQtyMin}
                      onChange={handleChange}
                      placeholder="Min Quantity"
                      min="1"
                      step="1"
                    />
                  </div>

                  {/* Agent Quantity Max */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Agent Quantity (Max)"
                      info="Maximum number of agents allowed."
                      id="agentMaxInfo"
                    />

                    <input
                      type="number"
                      name="agentQtyMax"
                      className="form-control"
                      value={formData.agentQtyMax}
                      onChange={handleChange}
                      placeholder="Max Quantity"
                      min="1"
                      step="1"
                    />
                  </div>

                  {/* Agent Discount */}
                  <div className="col-md-6 mb-3">
                    <InfoLabel
                      text="Agent Discount (%)"
                      info="Discount applied based on agent quantity."
                      id="discountInfo"
                    />

                    <input
                      type="number"
                      name="agentDiscount"
                      className="form-control"
                      value={formData.agentDiscount}
                      onChange={handleChange}
                      placeholder="Discount %"
                      min="0"
                      max="100"
                    />
                  </div>
                </div>

                {/* RIGHT-ALIGNED BUTTON */}
                <div className="mt-3 d-flex justify-content-end">
                  <button type="submit" className="btn btn-primary">
                    {id ? "Update Plan" : "Create Plan"}
                  </button>
                </div>

              </form>
            </div>

          </div>
        </main>

        <AdminFooter />
      </div>
    </div>
  );
};

export default AddAgentPlan;
